import { render, staticRenderFns } from "./BreadcrumbComponent.vue?vue&type=template&id=166f8d1b&lang=pug"
import script from "./BreadcrumbComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbComponent.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbComponent.vue?vue&type=style&index=0&id=166f8d1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports